import { render, staticRenderFns } from "./promo-bar.vue?vue&type=template&id=6e5d013a&"
import script from "./promo-bar.vue?vue&type=script&lang=js&"
export * from "./promo-bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports